import { EdgeListMessagesRepository } from '@/modules/connect/infra'
import type { ListMessages } from '@/modules/connect/use-cases'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'

export function makeListMessages(): ListMessages {
  return new EdgeListMessagesRepository(makeSupabaseEdgeHttpClient()).execute
}
